import { ComponentProps } from 'react';

import { cn } from '@/utils/styles';
import horizontalLight from '@/assets/images/vitazi-logo.png';
import horizontalDark from '@/assets/images/vitazi-logo-white.png';
import verticalLight from '@/assets/images/vitazi-logo-vertical.png';
import verticalDark from '@/assets/images/vitazi-logo-vertical-white.png';

const VARIANTS = {
  horizontal: {
    light: horizontalLight,
    dark: horizontalDark,
  },
  vertical: {
    light: verticalLight,
    dark: verticalDark,
  },
};

type LogoProps = ComponentProps<'img'> & {
  variant?: 'horizontal' | 'vertical';
};

export function Logo(props: LogoProps) {
  const { variant = 'horizontal', className = '', alt = 'Vitazi.ai Logo', ...rest } = props;

  return (
    <>
      <img
        src={VARIANTS[variant].light}
        className={cn('object-scale-down dark:hidden', className)}
        alt={alt}
        {...rest}
      />
      <img
        src={VARIANTS[variant].dark}
        className={cn('object-scale-down hidden dark:block', className)}
        alt={alt}
        {...rest}
      />
    </>
  );
}
